import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from "@fortawesome/free-solid-svg-icons";

export interface FeatureCheckProps {
    feature: string;
    label: string;
    featureArray: string[];
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    prerequisites?: string[];
    offset?: number;
    example?: string;
    onInfoClick?: (example: string | undefined) => void;
}

export const FeatureCheck = (props: FeatureCheckProps) => {
    let show = true;
    if(props.prerequisites !== undefined) {
        for(let prereq of props.prerequisites) {
            show = show && props.featureArray.includes(prereq);
        }
    }
    const offset = props.offset !== undefined? props.offset : 0;
    
    if(show) {
        return <Col md={{offset: offset}}>
            <Row className="align-items-center">
                <Col>
                    <Form.Check checked={props.featureArray.indexOf(props.feature) > -1} type="checkbox" label={props.label} 
                    value={props.feature} onChange={props.onChange}/>
                </Col>
                {props.example && (
                    <Col xs="auto">
                        <FontAwesomeIcon icon={faImage} onClick={() => props.onInfoClick && props.onInfoClick(props.example)} style={{ cursor: 'pointer' }} />
                    </Col>
                )}
            </Row>
        </Col>;
    } else {
        return <></>
    }
}